import { useEffect } from 'react'
import { Typography } from 'common/typography'
import styled from 'styled-components'
import useInputValue from 'hooks/use-input-value'
import Divider from 'common/divider'
import { SecondaryButton } from 'common/button'
import InputField from 'common/input-field'
import { useCompleteAccount } from 'mutations/profile'
import { useProfile } from 'querys/profile'
import { useRouter } from 'next/router'

const CompleteAccountStyled = styled.form`
  display: grid;
  row-gap: 16px;
`

function CompleteAccount() {
  const router = useRouter()
  const { data, isLoading } = useProfile()
  const { mutate } = useCompleteAccount()
  const username = useInputValue('')
  const name = useInputValue('')
  const lastname = useInputValue('')
  useEffect(() => {
    if (data) {
      const { username: gh_username, first_name, last_name } = data
      username.setValue(gh_username)
      name.setValue(first_name)
      lastname.setValue(last_name)
    }
  }, data)

  if (isLoading) return null

  const disabled = username.value === '' || name.value === '' || lastname.value === ''

  const completeAccount = (e) => {
    if (!disabled) {
      const payload = new FormData(e.target)
      mutate(payload, {
        onSuccess: () => {
          router.push(router.query.next || '/aprender')
        },
      })
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault(e)
    completeAccount(e)
  }
  const hadleKeyPress = (e) => {
    if (e.which === 13) {
      e.preventDefault(e)
      completeAccount(e)
    }
  }
  return (
    <>
      <Typography as="h1" small="regularBold" large="headline5">
        Completa tu cuenta
      </Typography>
      <Divider marginVertical={8} stroke={0} color="transparent" />
      <Typography as="p">
        Con el fin de mejorar la experiencia, completa todos los datos requeridos.
      </Typography>
      <Divider marginVertical={8} stroke={0} color="transparent" />
      <CompleteAccountStyled method="POST" onSubmit={handleSubmit}>
        <InputField
          label="Nombre de usuario"
          onChange={username.onChange}
          value={username.value}
          name="username"
          type="text"
          data-cy="complete-username"
          placeholder="Nombre que utilizaras en la plataforma"
          required
          fullWidth
        />
        <InputField
          label="Nombre"
          onChange={name.onChange}
          value={name.value}
          name="first_name"
          type="text"
          data-cy="complete-name"
          placeholder="Ingresa tu nombre"
          required
          fullWidth
        />
        <InputField
          label="Apellido"
          onChange={lastname.onChange}
          value={lastname.value}
          onKeyPress={hadleKeyPress}
          name="last_name"
          type="text"
          data-cy="complete-lastname"
          placeholder="Ingresa tu apellido"
          required
          fullWidth
        />
        <SecondaryButton
          type="submit"
          id="complete-btn"
          fontWeight={500}
          padding={16}
          height="48"
          fullWidth
          data-cy="complete-submit"
          disabled={disabled}
        >
          Guardar cambios
        </SecondaryButton>
      </CompleteAccountStyled>
    </>
  )
}

export default CompleteAccount
